import { FC, useRef, useState } from "react";
import images from "../../assets/images";
import './DocumentCard.scss';
import { useAppSelector } from "../../redux/app/hooks";
import { STUDENT_ROLE } from "../../utils/constants";
import { QuizData } from "../../pages/Quiz/Quiz";
import MaterialActionsOverlay, { MenuItemType } from "../ActionsOverlay/MaterialActionsOverlay";
import { Tooltip } from "@mui/material";

type DocumentCardType = {
    data: QuizData;
    tabName: string;
    image: string;
    handleClickShareDelete: (action: string, item: QuizData) => void;
    handleClickCard: (item: QuizData, isDisableView: boolean) => void;
}

const DocumentCard: FC<DocumentCardType> = ({ image, data, tabName, handleClickShareDelete, handleClickCard }) => {
    const { deleteIcon, forwardBlack, ResetCode, MoreIcon, PencilIcon, DeleteClass } = images;
    const role = useAppSelector((state) => state.auth.role);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [openOverlay, setOpenOverlay] = useState<boolean>(false);
    
    const menuItem: MenuItemType[] = [
        {
          icon: PencilIcon,
          label: "Edit",
          onClick: () => {
            handleClickShareDelete('edit', data)
            handleCloseActions();
          }
        },
        {
          icon: DeleteClass,
          label: "Delete",
          onClick: () => {
            handleClickShareDelete('delete', data)
            handleCloseActions();
          }
        }
    ]

    const handleCloseActions = () => {
        setAnchorEl(null);
        setOpenOverlay(false);
    };

    const handleClick = (e: React.MouseEvent<HTMLElement>, action: string) => {
        e.stopPropagation();
        handleClickShareDelete(action, data)
    }

    const handleClickMoreIcon = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setOpenOverlay(true);
    };

    const titleRef = useRef<HTMLDivElement | null>(null);
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);

    // Function to check if ellipsis is active
    const handleMouseEnter = () => {
        if (titleRef.current) {
            const isEllipsis = titleRef.current.scrollWidth > titleRef.current.clientWidth;
            setIsEllipsisActive(isEllipsis);
        }
    };

    return (
        <div className={`DocumentCard`} onClick={() => handleClickCard(data, openOverlay)}>
            <div className={ `CardContainer ${tabName === "Results" ? "ResultsCard" : ""}` }>
                <div className="DocumentCardImg">
                    <img src={ image } className="CardImg" alt="CardImg" />
                </div>
                {(role !== STUDENT_ROLE && tabName === "Quiz") && (
                    data?.results?.length > 0 ? (
                        <div className="deleteIcon" onClick={(e) => handleClick(e, "delete")}>
                            <img src={deleteIcon} className="deleteIconImg" alt="deleteIcon" />
                        </div>
                    ) : (
                        <div className="deleteIcon" onClick={(event) => handleClickMoreIcon(event)}>
                            <img src={MoreIcon} className="deleteIconImg" alt="deleteIcon" />
                        </div>
                    )
                )}
            </div>
            <div className="DocumentNameContiner">
            <Tooltip title={data?.quizTitle} disableHoverListener={!isEllipsisActive}>
            <div 
                ref={titleRef} 
                className={`DocumentName ${tabName === "Results" ? "DocumentNameResult" : ""}`} 
                onMouseEnter={handleMouseEnter} // Check on hover
                style={{ 
                    whiteSpace: "nowrap", 
                    overflow: "hidden", 
                    textOverflow: "ellipsis" 
                }}
            >
                {data?.quizTitle}
            </div>
        </Tooltip>              {(role !== STUDENT_ROLE && tabName === "Quiz") && (
                    <div className="forwardIcon" onClick={(e) => handleClick(e, data?.isClassroom ? "unshare" : "share")}>
                        <img src={ data?.isClassroom ? ResetCode : forwardBlack} className="forwardIconImg" alt="forwardIcon" />
                    </div>
                )}
                {(role !== STUDENT_ROLE && tabName === "Results") && (
                    <div className="totalScore">
                        <div className="total">Total</div>
                        <div className="totalCount">{ data?.totalCompletedStudents }</div>
                    </div>
                )}
                {(role === STUDENT_ROLE) && (
                    <div className="displayScore">
                        {(data?.status === "NOT_STARTED") 
                        ? <button className="startBtn">Start</button> 
                        : (data?.status === "INPROGRESS") 
                            ? <button className="startBtn continueBtn">Continue</button> 
                            : <button className="startBtn scoreBtn">
                                {`Scored ${data?.totalScore === 0 ? '0' : String(data?.totalScore).padStart(2, '0')}/${String(data?.totalQuestions).padStart(2, '0')}`}
                              </button>
                        }
                    </div>
                )}
            </div>
            <MaterialActionsOverlay
                anchorEl={anchorEl}
                open={openOverlay}
                handleClose={handleCloseActions}
                menuItems={menuItem}
                actionsHeight={'90px'}
                position="right"
                verticalPosition="bottom"
            />
        </div>
    )
}

export default DocumentCard;
